import React from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { getDivisor } from "../../../../utils/stripe-helpers";

const PlanCard = ({ data, activePlan = true, sub, selectedPlan }) => {
  const { t } = useTranslation("coaching-portal");
  const { currency, price } = data;
  const periodEnd = moment(sub.current_period_end);
  const recurring = selectedPlan?.recurring;
  const selectedPeriodEnd = recurring
    ? moment().add(recurring.interval_count, recurring.interval)
    : moment().add(1, "month");
  const renewDate = activePlan ? periodEnd : selectedPeriodEnd;
  const amount = activePlan
    ? price.unit_amount / getDivisor(price.currency)
    : selectedPlan.unit_amount / getDivisor(selectedPlan.currency);

  return (
    <article className="plan-card">
      <p>{activePlan ? t("membershipList.active") : t("membershipList.newPlan")}</p>
      <div>
        <div>
          <h5>{activePlan ? price.nickname : selectedPlan.nickname}</h5>
          <p className="p4">
            {t("membershipList.renewsOn", {
              date: renewDate.format("MMM D, YYYY"),
            })}
          </p>
        </div>
        <h1>
          <sup>{currency}</sup>
          {Number(amount).toLocaleString()}
        </h1>
      </div>
    </article>
  );
};

export default PlanCard;
